<div class="table-container">
  <table class="table" style="border-collapse: separate; border-spacing: 0">
    <thead>
      <tr>
        <th></th>
        <!-- Column for the icon open sub group -->
        <th></th>
        <!-- Column for Excel export button -->
        <th *ngFor="let column of columns">{{ column.header }}</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let row of dataSource">
        <!-- Main row -->
        <tr [class.expanded]="row === expandedRow">
          <td
            (click)="onRowClick(row)"
            [class.row-selected]="row === expandedRow"
            class="icon-cell cursor-pointer"
          >
            <i *ngIf="expandedRow === row && hasDetails(row)" class="icon-minus">[-]</i>
            <i *ngIf="expandedRow !== row && hasDetails(row)" class="icon-plus">[+]</i>
          </td>
          <td
            (click)="downloadExcel(row)"
            [class.row-selected]="row === expandedRow"
            class="icon-cell"
          >
            <span class="bg-green-600 py-1 px-2 rounded-lg text-white cursor-pointer">
              <fa-icon [icon]="faFileExcel"></fa-icon>
            </span>
          </td>
          <td *ngFor="let column of columns" [class.row-selected]="row === expandedRow">
            {{ column.cell(row) }}
          </td>
        </tr>
        <!-- Sub rows for the expanded main row -->
        <tr *ngIf="row === expandedRow && hasDetails(row)">
          <td [attr.colspan]="columns.length + 2" class="p-0">
            <!-- Adjust colspan to include the icon column -->
            <div class="detail-container">
              <table class="nested-table w-full">
                <thead>
                  <tr>
                    <th *ngFor="let detailColumn of detailColumns">{{ detailColumn.header }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let detail of row.dettaglio">
                    <td *ngFor="let detailColumn of detailColumns">
                      {{ detailColumn.cell(detail) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
